import type {CountryConfig} from '@pocketbuy/outdoor-business-types';
import {localPhone} from '../../components/LocalPhone';

type PhoneCountry=Pick<CountryConfig,'countryCode'|'callingCode'|'nationalNumberLength'>;
export function accountPhoneDisplay(value:string|undefined,country?:PhoneCountry):string {
  return value ? localPhone(value,country?.callingCode,country?.nationalNumberLength) : '';
}
export function validAccountPhone(value:string,country?:PhoneCountry):boolean {
  if(!value.trim())return true;
  if(!country)return false;
  let digits=value.replace(/\D/g,'');
  if(digits.startsWith('00'))digits=digits.slice(2);
  const national=digits.startsWith(country.callingCode)?digits.slice(country.callingCode.length):digits.startsWith('0')?digits.slice(1):digits;
  return new RegExp(`^\\d{${country.nationalNumberLength}}$`).test(national);
}
export function accountPhoneExample(country?:PhoneCountry):string {
  if(!country)return '';
  const examples:Record<string,string>={NG:'08012345678',GH:'0241234567'};
  return examples[country.countryCode]??`0${'1234567890'.repeat(3).slice(0,country.nationalNumberLength)}`;
}
